// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Shapes_wrapper__YUgC2","edges":"Shapes_edges__XihqA","flex":"Shapes_flex___CT_7","item":"Shapes_item__iznV6","active":"Shapes_active__pfLr5"};